import { render } from "./RolePermissionTab.vue?vue&type=template&id=6c2b7de8&scoped=true"
import script from "./RolePermissionTab.vue?vue&type=script&lang=js"
export * from "./RolePermissionTab.vue?vue&type=script&lang=js"

import "./RolePermissionTab.vue?vue&type=style&index=0&id=6c2b7de8&lang=scss&scoped=true"
import "./RolePermissionTab.vue?vue&type=style&index=1&id=6c2b7de8&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2b7de8"]])

export default __exports__